module.exports = __webpack_public_path__ + "static/media/antiClippyHalf.7d9748e2.png";